import { render, staticRenderFns } from "./DonutChart76.vue?vue&type=template&id=45b1ebf6&scoped=true&"
import script from "./DonutChart76.vue?vue&type=script&lang=js&"
export * from "./DonutChart76.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1ebf6",
  null
  
)

export default component.exports